import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { restoreCartItemsAndGoToResume } from '../repeat-order/restore-cart-items';
import { CartDraftService } from './cart-draft.service';

export const cartDraftGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const cartDraftService = inject(CartDraftService);
  const { draftId } = routeSnapshot.params;

  return restoreCartItemsAndGoToResume(draftId, establishmentId =>
    cartDraftService.getDraftCartItems(draftId, establishmentId),
  );
};
